import { CloudArrowDownIcon } from '@heroicons/react/24/outline'
import { useHistory } from 'react-router-dom'

type NewTemplateVersionTagProps = {
  templateId: string
  appId?: string
  spaceId?: string
  appName?: string
  isFromAppDetailsPage?: boolean
}
const NewTemplateVersionTag = ({
  templateId,
  appId,
  spaceId,
  appName,
  isFromAppDetailsPage = false
}: NewTemplateVersionTagProps) => {
  const history = useHistory()
  return isFromAppDetailsPage ? (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      onClick={e => {
        e.stopPropagation()
        history.push(`/space/${spaceId}/appbuilder/templates/${templateId}`, {
          fromUpdateVersion: true,
          isFromAppDetailsPage,
          appId,
          appName
        })
      }}
      className="fade-in flex cursor-pointer items-center rounded-md bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700 line-clamp-1 hover:bg-blue-200"
    >
      Update to new version
    </div>
  ) : (
    <div className="group relative">
      <span className="absolute bottom-full z-50 w-80 scale-0 rounded-md bg-white p-1 text-xs font-semibold text-gray-500 shadow-lg group-hover:scale-100">
        A new template is available! Review the release notes.
      </span>
      <CloudArrowDownIcon className="h-[20px] w-[20px] text-blue-700" title={'Update Available'} />
    </div>
  )
}

export default NewTemplateVersionTag
